export const validateFullName = (fullName) => {
    if (!fullName) {
      return "Please provide a full name.";
    }
    if (!/^[a-zA-Z.]+$/.test(fullName)) {
      return "Full name can only contain letters, dots, and cannot start or end with a dot.";
    }
    if(fullName.length > 20){
      return "Name should be less than 20 characters."
    }
    return "";
  };
  
  
  export const validateEmail = (email) => {
    if (!email) {
      return "Please provide an email address.";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Please provide a valid email address.";
    }
    if (/[^a-zA-Z0-9@._-]/g.test(email)) {
      return "Email contains special characters. Please remove them.";
    }
    return "";
  };
  
  export const validatePhoneNo = (phoneNo) => {
    if (!phoneNo) {
      return "Please provide a phone number.";
    }
    // if (!phoneNo || phoneNo.length !== 10 || isNaN(phoneNo)) {
    //   return "Please provide a valid 10-digit phone number.";
    // }
    if (/[^0-9]/g.test(phoneNo)) {
      return "Invalid Phone Number. Only digits are allowed.";
    }
    return "";
  };
  
  export const validatePassword = (password) => {
     const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    if (!password) {
      return "Please provide a password.";
    }
    if (!regex.test(password)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.";
    }
    if (password.length < 6) {
      return "Password must be at least 6 characters long.";
    }
  
    return "";
  };
  
  export const validateConfirmPassword = (confirmPassword, password) => {
    if (confirmPassword !== password) {
      return "Passwords do not match.";
    }
    return "";
  };
  
  export const validateOtp = (otp) => {
    if (!otp) {
      return "Please provide a otp.";
    }
    if (/[^0-9]+/g.test(otp)) {
      return "Please provide a valid otp ,otp contain only number .";
    }
    if (otp.length !== 6) {
      return "Please provide a valid otp of 6 digits.";
    }
    return "";
  };
  export const validateTermsAndConditions = (termsAndConditions) => {
    if (!termsAndConditions) {
      return "Please accept the terms and conditions.";
    }
    return "";
  }
  export const ValidateCoupenCode = (coupenCode) => {
    if (!coupenCode) {
      return "Please provide a coupen code.";
    }
    return "";
  };
  export const validateLoginPassword = (password) => {
   if (!password) {
     return "Please provide a password.";
   }
   return "";
  };